import { Tag, type TagValue } from "@listen-labs/o11y/metrics";

// Dimensions shared by more than one emitter, declared once so every call
// site spells them the same way. Identity (service, env, deployment_region)
// is not a Tag: it comes from the process identity (ddInit({ resource }) in
// the metrics SDK, the standard tag helper in the legacy path). Keep this to
// bounded dimensions; never add an entity id.

export const taskQueueTag = new Tag("task_queue");
export const workerTypeTag = new Tag("worker_type");
export const dbTargetTag = new Tag("db_target");
export const dbLayerTag = new Tag("db_layer");
export const statusTag = new Tag("status");
export const errorClassTag = new Tag("error_class");
export const workflowTypeTag = new Tag("workflow_type");
export const componentTag = new Tag("component");
export const activityTag = new Tag("activity");
export const phaseTag = new Tag("phase");
export const stepTag = new Tag("step");
export const areaTag = new Tag("area");
export const reasonTag = new Tag("reason");
export const errorPlaceTag = new Tag("error_place");
export const featureTag = new Tag("feature");
export const variantKindTag = new Tag("variant_kind");
// The Next route pattern with brackets as underscores (`/p/_id_/analysis/report`), never a concrete path.
export const routeTag = new Tag("route");

/** `key:value` for the legacy string-tag helpers in `utils/o11y/datadog.ts`. */
export const formatTag = ({ key, value }: TagValue): string =>
  `${key}:${value}`;
